var yy_request = require('../js/yunyin_request')
var po = require('../js/public_object.js')
var md5 = require("blueimp-md5")

module.exports = {
	data: function() {
		return {
			userName: '',
			userSID: '',
			userSch: '',
			userPhone: '',
			userMail: '',
			showPhoneEdit: false,
			showMailEdit: false,
			showPasswordEdit: false,
			newPhone: '',
			newMail: '',
			oldPwd: '',
			newPwd: '',
			newPwdRepeat: '',
			showCodeModal: false,
			verifyStage: 'code',
			verifyWay:'',
			verifyInfo:'',
		}
	},

	compiled: function() {
		var vuemodel = this
		if(po.userinfo!=null) {
			get_user_detail(vuemodel)
		} else {
		  yy_request.rest_api({
		    method: 'get',
		    api: 'user/',
		    opSuccess: function(info) {
		    	po.userinfo = info.user
		    	get_user_detail(vuemodel)
		    },
		  })			
		}
	},

	methods: {
		onChangePassword: function() {
			var vuemodel = this
			if(this.newPwd!=this.newPwdRepeat) {
				po.app.infoModalText = "两次密码输入不一致"
				po.app.showInfoModal = true
			} else {
			  yy_request.rest_api({
			    method: 'put',
			    api: 'user/' + po.userinfo.id,
			    data: {
						old: md5(this.oldPwd),
						password: md5(this.newPwd)			    
			    },
			    opSuccess: function(info) {
						po.app.infoModalText = "密码修改成功"
						po.app.showInfoModal = true
						vuemodel.showPasswordEdit = false
			    },
			    opFail: function(info) {
						po.app.infoModalText = info
						po.app.showInfoModal = true
			    },
			  })
			}
		},

		onBindPhone: function() {
			var vuemodel = this
		  yy_request.rest_api({
		    method: 'post',
		    api: "user/"+po.userinfo.id+"/phone",
		    data: {
  				phone: this.newPhone  
		    },
		    opSuccess: function(info) {
					vuemodel.verifyStage = 'code'
					vuemodel.verifyWay = 'phone'
					vuemodel.verifyInfo = vuemodel.newPhone
					vuemodel.showCodeModal = true
		    },
		    opFail: function(info) {
					po.app.infoModalText = info
					po.app.showInfoModal = true
		    },
		  })
		},


		onBindMail: function() {
			var vuemodel = this
		  yy_request.rest_api({
		    method: 'post',
		    api: "user/"+po.userinfo.id+"/email",
		    data: {
					email: this.newMail
		    },
		    opSuccess: function(info) {
					vuemodel.verifyStage = 'code'
					vuemodel.verifyWay = 'email'
					vuemodel.verifyInfo = vuemodel.newMail
					vuemodel.showCodeModal = true
		    },
		    opFail: function(info) {
					po.app.infoModalText = info
					po.app.showInfoModal = true
		    },
		  })
		},
	},

	components: {
    'verifycode-modal': require('../components/verifycode-modal.vue'),
	}
}

function get_user_detail(vuemodel) {
	yy_request.rest_api({
		method: 'get',
		api: 'user/' + po.userinfo.id,
		opSuccess: function(info) {
			vuemodel.userName = info.name
			vuemodel.userSID = info.number
			vuemodel.userSch = info.school 
			vuemodel.userPhone = info.phone || "还没有绑定手机" 
			vuemodel.userMail = info.email || "还没有绑定邮箱"    			
		},
	})
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/user-view.vue
// module id = 159
// module chunks = 0